import Asset from "../../../requests/apa/Asset";
import Translator from "../../../requests/apa/Translator";
import RequestManager from "../../../requests/RequestManager";
import CountriesTask from "../../../requests/tasks/sports/contriesTask";
import Utils from "../../../utils/Utils";
import { lettersTabs } from "../Paises/constants";

export const getCountries = async (idLeague) => {
    try {
        const countriesTask = new CountriesTask(idLeague);
        const response = await RequestManager.addRequest(countriesTask);
        if(!response) return [];

        const letters = new Set()
        const countries = response.data.teams
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(team => {
            const firstLetter = team.name.charAt(0)
            letters.add(firstLetter)
            return{
                id: team.teamId,
                name: team.name,
                logo: team && team.crestUrl ? team.crestUrl : Asset.get('eventodeportivo_placeholder_imagen_escudo_1'),
                flag: team && team.flagUrl ? team.flagUrl : Asset.get('eventodeportivo_placeholder_imagen_bandera_1'),
                color: team.primaryHex,
                favorited: team.isFavorite
            }
        })
            

        const tabs = [
            { id: Translator.get('eventodeportivo_paises_tabs_texto_tab1'), label: Utils.cutPlayerString(Translator.get('eventodeportivo_paises_tabs_texto_tab1'), 5) },
            ...Array.from(letters).sort().map(letter => ({ id: letter.toLowerCase(), label: Utils.cutPlayerString(Translator.get(lettersTabs[letter.toLowerCase()]), 1, undefined, '') }))
        ]

        return { countries: countries, tabs }
    }catch (error) {
        console.error('Error getting countries:', error);
        return { countries: [], tabs: [] };
    }
   

}


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/getCountries.js